import { MembersActionTypes } from './types';
import { all, takeLatest, call, put } from 'redux-saga/effects';
import Services from '../../services';
import { fetchAppFailure, initAppFailure } from 'redux/app/actions';
import {
  fetchMemberFailure,
  fetchMemberSuccess,
  fetchMemberSearchFailure,
  fetchOrgListByBoundarySuccess
} from './actions';

export function* doFetchMember(params: any) {
  try {
    const response = yield call(Services.member.fetchAllMember, {
      params: params.payload
    });
    if (response.error) {
      throw new Error(response.error.message);
    }
    yield put(fetchMemberSuccess(response));
  } catch (error) {
    yield put(fetchMemberFailure(error.message));
  }
}

export function* doFetchMemberBySearchTerm(request: any) {
  try {
    const members = yield call(Services.member.fetchAllMember, request.payload);
    if (!members.error) {
      yield put(fetchMemberSuccess(members));
    } else {
      yield put(fetchMemberSearchFailure(members.error.message));
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(fetchMemberSearchFailure(errorMsg));
    yield put(initAppFailure());
  }
}

// ORG LIST BY BOUNDARY/DESIGN-ACTIVITY-LIST/EXCAVATION-ACTIVITY-LIST
export function* doFetchOrgListByBoundary(request: any) {
  try {
    // ORGANISATION LIST API CALL
    const res = yield call(
      Services.member.fetchOrgListByBoundaryService,
      request.payload,
      100
    );

    if (!res.errors && res.Organisations) {
      yield put(fetchOrgListByBoundarySuccess(res));
    } else {
      yield put(fetchAppFailure(res.errors[0].message));
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(fetchAppFailure(errorMsg));
  }
}

export function* onFetchMember() {
  yield takeLatest(MembersActionTypes.FETCH_MEMBER_START, doFetchMember);
}

export function* onFetchMemberBySearchTerm() {
  yield takeLatest(
    MembersActionTypes.FETCH_MEMBER_SEARCH_START,
    doFetchMemberBySearchTerm
  );
}

export function* onFetchOrgListByBoundary() {
  yield takeLatest(
    MembersActionTypes.SET_ORG_LIST_BY_BOUNDARY_START,
    doFetchOrgListByBoundary
  );
}
export function* doRemoveError() {}

function* onRemoveError() {
  yield takeLatest(MembersActionTypes.REMOVE_ERROR, doRemoveError);
}
export function* membersSagas() {
  yield all([
    call(onFetchMember),
    call(onFetchMemberBySearchTerm),
    call(onFetchOrgListByBoundary),
    call(onRemoveError)
  ]);
}

export default membersSagas;
